export default __webpack_public_path__ + "static/media/Ball.1feafaa2.svg";